import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { ConsoleService } from '../../services/console.service';
import { MultiFacilityService } from '../../services/multi-facility.service';
import { OnDemandClassesService } from '../../services/on-demand-classes.service';
import { IOnDemandClassesWrapper, IOnDemandClassesUpdateWrapper, IOnDemandClassesEquipment, IstatusCountData, IBandwidth } from '../../services/on-demand-classes.service.model';

@Component({
  selector: 'app-life-fitness-on-demand-premium',
  templateUrl: './life-fitness-on-demand-premium.component.html',
  styleUrls: ['./life-fitness-on-demand-premium.component.css']
})
export class LifeFitnessOnDemandPremiumComponent implements OnInit, OnDestroy {
  // subscriptions
  private _facilityOnChange: Subscription;
  private _consoleOnChange: Subscription;
  private lastSelectedFacilities: string[];
  private timeout: any;

  rootScopeData: RootScopeDeclare;
  onDemandData: IOnDemandClassesWrapper;
  postOnDemandData: IOnDemandClassesUpdateWrapper;

  productInfoGridData: IOnDemandClassesEquipment[];
  statusCountData: IstatusCountData;
  isEquipmentListFetched = false;
  showDisableModal = false;
  showOutdatedSoftwareModal = false;
  isEnabled: string;
  assetList = [];
  showToast = false;
  toastMessage: string;
  LFOnDemandConsoles = ['superman', 'hal', 'mulder'];
  productInfoHeaderColumn: object;
  currentConsole: string;
  userPermission: boolean = false;
  warningMessage: string | SafeHtml;
  showBandwidthModal = false;
  recommendedBandwidth: IBandwidth[] = [];

  breadCrumbData = [
    { pageName: 'DASHBOARD', path: '/dashboard' },
    { pageName: 'MENU.EQUIPSETTING' },
    { pageName: 'LF.ON.DEMAND.CLASSES' },
  ];

  disabledPopupProperties = {
    title: 'DISABLE.LF.ON.DEMAND.CLASSES',
    message: 'DISABLE.LF.ON.DEMAND.CLASSES.MSG',
    isWarningPopup: false,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };

  outdatedSoftwarePopupProperties = {};

  productInfoHeaderData = [
    { columnName: 'PRODUCT.INFORMATION' },
    { columnName: 'STATUS' },
    { columnName: 'CONFIRMATION' },
    { columnName: 'SELECT.ALL.EQUIPMENT' },
  ];

  productInfoHeaderDataForXs = [{ columnName: 'STATUS' }, { columnName: 'SELECT.ALL.EQUIPMENT' }];
  displayPreviewModal = false;
  consoleTypeMsg: string;


  @ViewChild('lfOnDemandClasses', { static: false }) lfOnDemandClasses: ElementRef;
  status: string;

  constructor(
    private rootScopeService: RootScopeService,
    private onDemandClassesService: OnDemandClassesService,
    public commonUtil: CommonUtil,
    private router: Router,
    private amplitudeAnalytics: AmplitudeAnalyticsService,
    private toast: HaloToastService,
    private _facilityService: FacilityService,
    private _multiFacilityService: MultiFacilityService,
    private _consoleService: ConsoleService,
    private loader: HaloLoaderService,
    private _tips: HaloTipsService
  ) {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  setDraftedFlag(): void {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  updateOnDemandData() {
    if (!this.hasPermission()) {
      this.commonUtil.redirectToAvailablePage();
    }
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {      
      this.getOnDemandClassesDetails();
    }, 300);
  }

  ngOnInit() {
    this.getRootScopeData();
    this.setPageName();
    // subscript facility change / when facility change
    this._facilityOnChange = this._multiFacilityService.selectedFacilityListSource.subscribe(res => {  
      res = res.slice().sort();
      if(JSON.stringify(this.lastSelectedFacilities) !== JSON.stringify(res)) {
        this.lastSelectedFacilities = res;
        this.updateOnDemandData();
        this.getHeaderMessage();
      }
    });

    // subscribe console change / when console change
    this.currentConsole = this._consoleService.selectedConsole();
    this._consoleOnChange = this._consoleService.selectedConsoleSource.subscribe(res => {
      if(this.currentConsole != res) {
        this.currentConsole = res;        
        this.updateOnDemandData();
      }
    });
    
    this.changeProductInfoHeaderData();
    const moduleTitle =
      this.commonUtil.translateText('HALO.FITNESS.CLOUD') + ' - ' + this.commonUtil.translateText('MENU.EQUIPSETTING');
    this.commonUtil.setTitle(moduleTitle);
    const gettingStartedLink = [
      '<a class="gettingStartedLink"  target="_blank" href="https://halofitness.zendesk.com/hc/en-us/articles/360031436651">' +
      this.commonUtil.translateText('HERE') +
      '</a>',
    ];
    this.warningMessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText(
      'LF.ON.DEMAND.CLASS.WARNING.MSG',
      gettingStartedLink
    );
    this.lastSelectedFacilities = this._facilityService.selectedMultiFacilities();
    this.getHeaderMessage();
    this.updateOnDemandData();
    this.showHaloTips();
    this.scroll();

    // static data
    this.recommendedBandwidth = this.onDemandClassesService.recommendedBandwidths();
  }

  getHeaderMessage(){
    let lfOnDemandTxt = this.getLfOnDemandConsoles();
    this.consoleTypeMsg = `${this.commonUtil.replaceValueAsHTMLOnTranslatedText(
      'LF.ON.DEMAND.CLASSES.HEADER.MSG',
      [lfOnDemandTxt])} <a href="https://halofitness.zendesk.com/hc/en-us/articles/360060481692" target="_blank"> ${this.commonUtil.translateText('LEARN.MORE')} </a>`   
  }

  getLfOnDemandConsoles() {
    let supportedConsolesTxt: string = '';
    let supportedConsoles: string[] = [];
    this.lastSelectedFacilities?.forEach(f => {
      let fac = this._facilityService.getFacilityById(f);
      fac?.consoleEquipments      
      ?.filter((console) => this.LFOnDemandConsoles.includes(console.consoleType)? console.consoleType: '')
      .forEach((console) => supportedConsoles.push(this.rootScopeData.consoleRights.get(console.consoleType).consoleName));
    });
    supportedConsolesTxt = supportedConsoles
      .filter((v, i, a) => a.indexOf(v) === i)
      ?.join(', ')
      .replace(/,(?!.*,)/gim, ' ' + this.commonUtil.translateText('AND'));
    return supportedConsolesTxt;
  }
  
  ngOnDestroy() {
    // $('#atlwdg-trigger').css('display', "none");
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
    this._consoleOnChange.unsubscribe();
    this._tips.onDismissed(true);
  }

  @HostListener('window:resize', ['$event'])
  setScreenSize(): void {
    this.changeProductInfoHeaderData();
  }

  changeProductInfoHeaderData(): void {
    this.productInfoHeaderColumn =
      this.rootScopeData.screenSize == 'xs' || this.rootScopeData.screenSize == 'sm'
        ? this.productInfoHeaderDataForXs
        : this.productInfoHeaderData;
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'onDemandClasses';
  }

  getOnDemandClassesDetails() {
    this.userPermission = this.hasEditPermission();
    if (this.currentConsole && this.LFOnDemandConsoles.indexOf(this.currentConsole.toString()) > -1) {
      this.loader.startProcess();
      this.onDemandClassesService
        .getOnDemandClassesPremium(this._facilityService.selectedMultiFacilities(), this.currentConsole)
        .subscribe(
          (data: IOnDemandClassesWrapper) => {
            this.loader.endProcess();
            this.onDemandData = data;
            this.isEquipmentListFetched = true;
            this.isEnabled = this.onDemandData.enabledStatus;
            this.constructDataForProductInfoGrid(this.onDemandData);
            this.constructDataForStatusLegend(this.onDemandData);
          },
          error => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
    }
  }

  constructDataForStatusLegend(data: IOnDemandClassesWrapper): void {
    this.statusCountData = {
      connectedCount: data.connectedCount,
      idleCount: data.idleCount,
      notConnectedCount: data.notConnectedCount,
      showIdle: false
    };
  }

  constructDataForProductInfoGrid(data: IOnDemandClassesWrapper): void {
    if (data.equipmentList) {
      this.productInfoGridData = data.equipmentList.map((x: IOnDemandClassesEquipment) => {
        x.assetList = x.assetList.map((a) => {
          if (a.updatedDate) {
            a.updatedDate = this.commonUtil.localizeDate(Number(a.updatedDate));
          }
          if (a.onlineStatus === 'C') {
            a.publishedStatusWarning = false;
            if (a.enabledStatus === 'true') {
              a.publishedStatus = this.commonUtil.translateText('ENABLED');
            } else if (a.enabledStatus === 'false') {
              a.publishedStatus = this.commonUtil.translateText('DISABLED');
            } else {
              a.publishedStatus = '';
            }
          } else if (a.onlineStatus === 'NC') {
            a.publishedStatusWarning = true;
            if (a.enabledStatus === 'true') {
              a.publishedStatus = this.commonUtil.translateText('ENABLED.NOT.CONNECTED');
            } else if (a.enabledStatus === 'false') {
              a.publishedStatus = this.commonUtil.translateText('DISABLED.NOT.CONNECTED');
            } else {
              a.publishedStatus = '';
              a.publishedStatusWarning = false;
            }
          } else {
            a.publishedStatus = '';
            a.publishedStatusWarning = false;
          }
          a.currentConsole = this.currentConsole.toUpperCase();
          return a;
        });
        return x;
      });
    }
  }

  assetListDataHandler(assetData: never): void {
    this.assetList = assetData;
    if (this.assetList.length > 0) {
      this.setDraftedFlag();
    }
  }

  openBandwidthModal() {
    this.showBandwidthModal = true;
  }

  closeBandwidthModal() {
    this.showBandwidthModal = false;
  }

  publishOnDemandClasses() {
    // this.childProductInfoGrid.getAssetValues();
    // const finalInput = {
    //   facilityId: this.currentFacility.facilityId,
    //   consoleType: this.currentConsole,
    //   enabledStatus: this.isEnabled,
    //   assetIds: this.assetList,
    //   productType: 'Premium'
    // };
    // this.rootScopeData.showAjaxLoader = true;
    // this.onDemandClassesService.publishOnDemandClassesPremium(finalInput).subscribe(
    //   (data: IOnDemandClassesWrapper) => {
    //     this.onDemandData = data;
    //     this.constructDataForProductInfoGrid(this.onDemandData);
    //     this.constructDataForStatusLegend(this.onDemandData); // check with ramesh whether this is needed
    //     this.rootScopeData.showAjaxLoader = false;
    //     if (this.onDemandData.outdatedAssetCount && this.onDemandData.outdatedAssetCount > 0) {
    //       this.showOutdatedSoftwareModal = true;
    //       this.setOutdatedSoftwarePopupData();
    //     } else {
    //       // this.showToast = true;
    //       this.currentFacility.summary.hasOnDemandClassesSetup = 'true';
    //       this.amplitudeAnalytics.logEvent(
    //         'Life Fitness On Demand Premium - ' + this.status + ' - Publish',
    //         { Console_Type: this.currentConsole }
    //       );
    //       if (this.isEnabled === 'true') {
    //         this.toastMessage = this.commonUtil.translateText('LF.ON.DEMAND.CLASSES.ENABLE.PUBSLISH.MSG');
    //       } else {
    //         this.toastMessage = this.commonUtil.translateText('LF.ON.DEMAND.CLASSES.DISABLE.PUBSLISH.MSG');
    //       }
    //       this.toast.creatToast(this.toastMessage);
    //     }
    //     if (this.isEnabled === 'true') {
    //       this.status = 'Enable';
    //       this.amplitudeAnalytics.logEvent(
    //         'Life Fitness On Demand Premium - Internet Bandwidth - Yes Continue',
    //         { Console_Type: this.currentConsole }
    //       );
    //       this.closeBandwidthModal();
    //     } else {
    //       this.status = 'Disable';
    //     }
    //     this.rootScopeData.isPageHasUnsavedChanges = false;
    //   },
    //   error => {
    //     this.rootScopeData.showAjaxLoader = false;
    //     if (this.isEnabled === 'true') {
    //       this.closeBandwidthModal();
    //     }
    //     console.error('API failed.');
    //   }
    // );
  }

  checkEnableDisablePublish() {
    if (this.isEnabled === 'true') {
      this.openBandwidthModal();
      this.status = 'Enable';
    } else {
      this.publishOnDemandClasses();
      this.status = 'Disable';
    }
  }

  setOutdatedSoftwarePopupData() {
    const assetCount: string = JSON.stringify(this.onDemandData.outdatedAssetCount);
    this.outdatedSoftwarePopupProperties = {
      title: 'OUTDATED.SOFTWARE.VERSION',
      message: this.commonUtil.replaceValueAsHTMLOnTranslatedText('OUTDATED.SOFTWARE.VERSION.MSG', [
        assetCount,
        '4.19',
      ]),
      needHelp: 'NEED.HELP',
      needHelpLink: 'https://halofitness.zendesk.com/hc/en-us/articles/360031436651',
      isWarningPopup: true,
      ctaButtonLabel: 'UPDATE.SOFTWARE',
      negativeButtonLabel: 'OK',
      isCloseIconCallsCta: false,
      isSecondaryTextButton: true,
    };
  }

  showDisableConfirmationModal() {
    if (this.isEnabled === 'true') {
      this.showDisableModal = true;
    }
  }
  setenableToggle() {
    if (this.isEnabled === 'false') {
      //
    }
  }
  needHelpLink() {
    //
  }
  onPositiveConfirmation() {
    this.showDisableModal = false;
    this.setDraftedFlag();
  }

  closeDisabledModal() {
    this.isEnabled = 'true';
    this.showDisableModal = false;
  }

  goToSofwarePage() {
    this.router.navigate(['/software']);
  }

  closeOutdatedSoftwareModal() {
    this.showOutdatedSoftwareModal = false;
  }

  closeToast(): void {
    this.showToast = false;
  }

  showPreviewPopup() {
    this.displayPreviewModal = true;
  }
  onPressofCancel() {
    this.displayPreviewModal = false;
  }

  scroll() {
    setTimeout(() => {
      this.lfOnDemandClasses.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  showHaloTips() {
    if (this.rootScopeData.showLFODPremiumTooltip) {
      this._tips.add([
        { flag: 'showLFODPremiumTooltip', key: 'select-facility', message: this.commonUtil.translateText('LF.ON.DEMAND.PREMIUM.FACILITY.TOOLTIP') },
        { flag: 'showLFODPremiumTooltip', key: 'lfod-enable-disable', message: this.commonUtil.translateText('LF.ON.DEMAND.PREMIUM.TOGGLE.TOOLTIP') },
        { flag: 'showLFODPremiumTooltip', key: 'select-equipment', message: this.commonUtil.translateText('LF.ON.DEMAND.PREMIUM.EQUIPMENT.TOOLTIP'), pointerPosition: 'bottom' },
      ]);
    }
  }

  hasEditPermission() {
    if(this.lastSelectedFacilities){
      return this.lastSelectedFacilities.some(s => {
        let fac = this._facilityService.getFacilityById(s);
        if(fac && fac.summary && fac.summary.facilityRights.lfodEnabledEquipment === 'true' && fac?.summary?.userRights?.lfodEnabledEquipment === 'F' ||
          fac?.summary?.isLoggedInManagerAdmin === 'true') return true;
        else return false;
      });
    }else{
      return false;
    } 
  } 

  hasPermission() {
    return this._multiFacilityService.isMultifacilitySupported(this.router.url);
  }
}
